import { apiClient } from "./apiClient";

export const recordsApi = {
  myEventsRecords: ({ page = 1, pageSize = 10, signal } = {}) => {
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
    });
    return apiClient.get(
      `${process.env.REACT_APP_RECORDS_PATH}/my?${params.toString()}`,
      { signal },
    );
  },

  getRecord: (recordId) => {
    return apiClient.get(`${process.env.REACT_APP_RECORDS_PATH}/${recordId}`);
  },

  deleteEventRecord: (recordId) => {
    return apiClient.delete(
      `${process.env.REACT_APP_RECORDS_PATH}/${recordId}`,
    );
  },

  confirmPayment: (recordId) => {
    return apiClient.post(
      `${process.env.REACT_APP_RECORDS_PATH}/${recordId}/confirm`,
    );
  },

  cancelPayment: (recordId) => {
    return apiClient.post(
      `${process.env.REACT_APP_RECORDS_PATH}/${recordId}/cancel`,
    );
  },
};
